export { default } from "./image";